import { IMatSelectOption } from "../../../../shared/interfaces/common.interface";

export enum TravelDestinationEnum {
    Domestic = "D",
    Asia = "A",
    Worldwide = "W",
}

export const TRAVEL_DESTINATION_LABEL_MAP = {
    [TravelDestinationEnum.Domestic]: "Domestic",
    [TravelDestinationEnum.Asia]: "Asia",
    [TravelDestinationEnum.Worldwide]: "Worldwide",
};

export function getTravelDestinationLabel(destination: TravelDestinationEnum | null): string {
    if (destination === null) {
        return "";
    }
    return TRAVEL_DESTINATION_LABEL_MAP[destination] || "";
}

export function getTravelDestinationOptions(): IMatSelectOption[] {
    return [
        {
            id: TravelDestinationEnum.Domestic,
            label: getTravelDestinationLabel(TravelDestinationEnum.Domestic),
        },
        {
            id: TravelDestinationEnum.Asia,
            label: getTravelDestinationLabel(TravelDestinationEnum.Asia),
        },
        {
            id: TravelDestinationEnum.Worldwide,
            label: getTravelDestinationLabel(TravelDestinationEnum.Worldwide),
        },
    ];
}
